import { render } from "./input_groups.vue?vue&type=template&id=65aa66fa"
import script from "./input_groups.vue?vue&type=script&lang=js"
export * from "./input_groups.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__